<template>
  <div class="publishing-schedule">
    <LabeledText
      :label="label"
      :subLabel="subLabel"
      :clickable="isClickable"
      @click="handleClick"
    >
      <template v-slot:icon>
        <CheckIcon v-if="isPublished" />
        <WaitingIcon v-else-if="isPending" />
        <StopIcon v-else />
      </template>
      <template v-slot:action>
        <Permissioned section="publishing-schedules" :id="unitId">
          <PrimaryButton
            class="mx-1"
            permission="edit-booking-publishing-schedule.edit-cost"
            @click.native="updateAction('editCost')"
            shrink
            light
          >
            Edit Cost
            <v-icon class="ml-1">mdi-pencil</v-icon>
          </PrimaryButton>
          <PrimaryButton
            class="mx-1"
            permission="edit-booking-publishing-schedule.publish"
            @click.native="updateAction('publish')"
            shrink
            light
          >
            Publish
            <v-icon>mdi-arrow-up-thick</v-icon>
          </PrimaryButton>
          <PrimaryButton
            class="mx-1"
            permission="edit-booking-publishing-schedule.restart"
            @click.native="updateAction('restart')"
            shrink
            light
          >
            Restart
            <v-icon>mdi-restart</v-icon>
          </PrimaryButton>
          <ErrorButton
            class="mx-1"
            permission="edit-booking-publishing-schedule.cancel"
            @click.native="updateAction('cancel')"
            dense
            shrink
            light
          >
            Cancel
            <v-icon>mdi-close</v-icon>
          </ErrorButton>
          <BaseButton
            class="mx-1"
            permission="edit-booking-publishing-schedule.pause"
            @click.native="updateAction('pause')"
            dense
            shrink
          >
            Pause
            <v-icon>mdi-pause</v-icon>
          </BaseButton>
          <ErrorButton
            class="mx-1"
            permission="edit-booking-publishing-schedule.stop"
            @click.native="updateAction('stop')"
            dense
            shrink
            light
          >
            Stop
            <v-icon>mdi-stop</v-icon>
          </ErrorButton>
        </Permissioned>
      </template>
      <div class="publishing-schedule__publish-date">
        {{ publishOnDate || "-" }}
      </div>
    </LabeledText>
    <PublishingScheduleActionDialog
      v-if="isDialogOpen"
      :is-open="isDialogOpen"
      :agency="{ name: label, id: unitId }"
      :action="action"
      :label="label"
      :currentCost="cost"
      :currencyCode="currencyCode"
      @close="isDialogOpen = false"
      @update="handleUpdate"
    />
  </div>
</template>

<script>
import CheckIcon from "@/components/bookings/CheckIcon";
import WaitingIcon from "@/components/bookings/WaitingIcon";
import StopIcon from "@/components/bookings/StopIcon";
import LabeledText from "@/components/common/BaseDetails/LabeledText";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import BaseButton from "@/components/common/Button/BaseButton";
import ErrorButton from "@/components/common/Button/ErrorButton";
import PublishingScheduleActionDialog from "@/views/bookings/components/ConfirmDialogs/PublishingScheduleActionDialog";
import Permissioned from "@/components/common/Permissioned";
import moment from "moment";

export default {
  name: "PublishScheduleItem",
  components: {
    Permissioned,
    PublishingScheduleActionDialog,
    CheckIcon,
    WaitingIcon,
    LabeledText,
    PrimaryButton,
    BaseButton,
    ErrorButton,
    StopIcon
  },
  data() {
    return {
      isDialogOpen: false,
      action: "publish"
    };
  },
  computed: {
    isPublished() {
      return this.status === "published";
    },
    isPending() {
      return this.status === "pending";
    },
    subLabel() {
      const currency = this.$options.filters.currency;
      const currencyCode = this.currencyCode || "GBP";
      return this.cost && `(${currency(this.cost, currencyCode)})`;
    },
    isClickable() {
      return Boolean(this.url);
    },
    publishOnDate() {
      return (
        this.publishingDate &&
        moment(this.publishingDate).format("DD MMMM YYYY, HH:mm")
      );
    }
  },
  methods: {
    handleUpdate() {
      this.$emit("updated");
    },
    updateAction(action) {
      this.action = action;
      this.isDialogOpen = true;
    },
    handleClick() {
      if (this.isClickable) {
        window.open(this.url, "_blank");
      }
    }
  },
  props: {
    status: String,
    label: String,
    cost: Number,
    currencyCode: String,
    unitId: String,
    publishingDate: String,
    url: String
  }
};
</script>

<style lang="scss"></style>
